import React from 'react';
import { IndeterminateProgress } from './BrandPresenceSkeleton';
import { BP_CARD_CLASSES } from './brandPresenceClasses';

export function GovernanceAnalyticsSectionCard({
  title,
  description,
  actions,
  children,
  className,
  headerClassName,
  loading,
}: {
  title: string;
  /** One line under the title saying how to read the section. */
  description?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  /** Extra classes for the header, such as a minimum height shared with a card beside it. */
  headerClassName?: string;
  loading?: boolean;
}) {
  const heading = <h2 className="m-0 text-[0.9375rem] font-bold tracking-tight text-slate-900">{title}</h2>;

  return (
    <section className={`${BP_CARD_CLASSES} motion-safe:animate-bp-fade-up ${className || ''}`} aria-busy={loading || undefined}>
      <header
        className={`flex flex-wrap items-center justify-between gap-3 border-b border-slate-200/70 px-5 py-3.5 ${headerClassName || ''}`}
      >
        {description ? (
          <div className="min-w-0">
            {heading}
            <p className="m-0 mt-0.5 text-xs text-slate-500">{description}</p>
          </div>
        ) : (
          heading
        )}
        {actions ? <div className="flex flex-wrap items-center justify-end gap-2">{actions}</div> : null}
      </header>
      {/* While the section refetches its figures stay in place, dimmed, under a thin running bar. */}
      <IndeterminateProgress active={!!loading} label={`Loading ${title}`} />
      <div className={`relative p-5 transition-opacity duration-300 ${loading ? 'pointer-events-none opacity-45' : 'opacity-100'}`}>
        {children}
      </div>
    </section>
  );
}
